import { environment } from '../../utils/fetchEnv'
import { getBlaize } from '../../utils/getBlaize'

const fetchCases = async (sessionId: string): Promise<CustomerAppointmentsResponse> => {
  const noCases = { pastCases: [], upcomingCases: [], clientId: '' }

  return fetch(
    `https://${environment()}-appointment-booking-rebooking-service.api.product.which.co.uk/rebooking-service/customer-appointments`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: sessionId,
        'User-Agent': window.navigator.userAgent,
        'X-Forwarded-Application': `which-tool-framework/${environment()}`,
      },
    }
  )
    .then((responseData) => (responseData.ok ? responseData.json() : noCases))
    .catch(() => noCases)
}

export const fetchSimilarCase = async (caseType: string): Promise<SimilarCaseMatch> => {
  const sessionId = getBlaize()

  const appointmentData = await fetchCases(sessionId)

  const foundSimilarCase = appointmentData.upcomingCases.find(
    (caseView) => caseView.title === caseType
  )

  if (foundSimilarCase) {
    return {
      similarCase: foundSimilarCase,
      foundSimilarCase: true,
    }
  }

  return { foundSimilarCase: false }
}

type AppointmentView = {
  id: string
  startTime: string
  endTime: string
}

export type CaseView = {
  caseNumber: string
  title: string
  category: 'legal' | 'tech' | 'money'
  isEntitled: boolean
  appointment: AppointmentView
  description?: string
}

export type SimilarCaseMatch =
  | { foundSimilarCase: false }
  | { foundSimilarCase: true; similarCase: CaseView }

type CustomerAppointmentsResponse = {
  clientId: string
  upcomingCases: CaseView[]
  pastCases: CaseView[]
}
